import classNames from 'classnames';
import React, {ReactElement} from 'react';

import Row from '../../common/Row';

type Props = {
  className?: string;
};

const DotsLoader = ({className}: Props): ReactElement => {
  return (
    <Row className={classNames('h-4 gap-2', className)}>
      <Dot />
      <Dot delay={'500ms'} />
      <Dot delay={'1s'} />
    </Row>
  );
};

const Dot = ({delay}: {delay?: string}): ReactElement => {
  return (
    <div
      className={'flex-none inline-block w-4 h-4 bg-current rounded-full animate-pulse transition-[opacity]'}
      style={{animationDelay: delay, animationDuration: '1.5s'}}
      role="status"
    ></div>
  );
};
export default DotsLoader;
